import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// ----------------------------------------------------------------------

/**
 * Mostra la pagina solo se userData contiene il flag di permesso indicato (lo stesso
 * usato dalla sidebar per nascondere la voce), altrimenti rimanda alla dashboard admin.
 * È un filtro di navigazione: i permessi effettivi restano verificati dal backend.
 */
RequirePermission.propTypes = {
  auth: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default function RequirePermission({ auth, children }) {
  let userData = null;

  try {
    userData = JSON.parse(localStorage.getItem('userData'));
  } catch (e) {
    userData = null;
  }

  if (!userData || !userData[auth]) return <Navigate to="/admin/dashboard" replace />;

  return children;
}
